import { ExprNode } from './ExprNode';
import { EvalState } from './Eval/EvalState';
export var ExprEval;
(function (ExprEval) {
    function reduce(exprNode, items) {
        const state = ExprNode.reduce(EvalState.make(items), exprNode, EvalState.reducer);
        const values = new Array(items.length);
        for (let itemIdx = 0; itemIdx < items.length; itemIdx++) {
            const value = EvalState.getValue(state, exprNode, itemIdx);
            if (value === undefined) {
                throw new Error(`Final value of evaluation is undefined`);
            }
            values[itemIdx] = value;
        }
        return values;
    }
    ExprEval.reduce = reduce;
})(ExprEval || (ExprEval = {}));
